<footer class="footer-wrapper">
  <div class="top-section">
    <img
      src="/footer/png/ribera_logo_footer.png"
      alt="Ribera del Río"
      class="footer-logo"
    />

    <p class="description">
      Un refugio natural en Cieneguilla donde el lujo, la tranquilidad y la
      naturaleza se unen para crear experiencias inolvidables.
    </p>

    <div class="social-icons">
      <a [href]="getSocialUrl(40)" aria-label="Facebook"
        ><i class="pi pi-facebook"></i
      ></a>
      <a [href]="getSocialUrl(41)" aria-label="TikTok"
        ><i class="pi pi-tiktok"></i
      ></a>
      <a href="#" aria-label="YouTube"><i class="pi pi-youtube"></i></a>
      <a [href]="getSocialUrl(42)" aria-label="Instagram"
        ><i class="pi pi-instagram"></i
      ></a>
    </div>
  </div>

  <div class="section links-section">
    <h3 class="section-title">Enlaces Rápidos</h3>

    <div class="links-content">
      <ul class="custom-list">
        <li>
          <img
            src="/footer/enlaces/caret-right.png"
            alt="Caret Right"
            class="icon caret-right-icon"
          />
          <a routerLink="/test-about">Nosotros</a>
        </li>
        <li>
          <img
            src="/footer/enlaces/caret-right.png"
            alt="Caret Right"
            class="icon caret-right-icon"
          />
          <a routerLink="/services/restaurant">Restaurante</a>
        </li>
        <li>
          <img
            src="/footer/enlaces/caret-right.png"
            alt="Caret Right"
            class="icon caret-right-icon"
          />
          <a routerLink="/services/experiences">Experiencias</a>
        </li>
        <li>
          <img
            src="/footer/enlaces/caret-right.png"
            alt="Caret Right"
            class="icon caret-right-icon"
          />
          <a routerLink="/bookings">Alojamiento</a>
        </li>
        <li>
          <img
            src="/footer/enlaces/caret-right.png"
            alt="Caret Right"
            class="icon caret-right-icon"
          />
          <a routerLink="/test-contact">Contacto</a>
        </li>
      </ul>

      <div class="mascot-container">
        <img
          src="/footer/enlaces/mascota_footer.png"
          alt="Mascota Ribera"
          class="mascot-img"
        />
      </div>
    </div>
  </div>

  <div class="section contact-section">
    <h3 class="section-title">Contactos</h3>

    <ul class="contact-list">
      <li>
        <img
          src="/footer/contactos/map-pin.png"
          alt="Map Marker"
          class="icon map-marker-icon"
        />
        <span>Km 29.5 Carretera Lima - Cieneguilla, Cieneguilla, Peru</span>
      </li>
      <li>
        <img
          src="/footer/contactos/envelope.png"
          alt="Email"
          class="icon email-icon"
        />
        <span>reservas@cieneguillariberadelrio.com</span>
      </li>
      <li>
        <img
          src="/footer/contactos/phone-square.png"
          alt="Whatsapp"
          class="icon whatsapp-icon"
        />
        <span>+51 938 627 411</span>
      </li>
    </ul>
  </div>

  <div class="claims-section">
    <a routerLink="/complaints-book" class="claims-box">
      <span>Libro de reclamaciones</span>
      <img
        src="/footer/png/libro.png"
        alt="Libro de reclamaciones"
        class="icon book-icon"
      />
    </a>
  </div>

  <hr class="divider" />

  <div class="bottom-section">
    <div class="legal-links">
      <a routerLink="/terms-conditions">Términos y condiciones</a>
      <a routerLink="/usage-policy">Política de Uso de Datos</a>
      <a routerLink="/acceptable-policies">Política de Uso Aceptable</a>
    </div>

    <hr class="divider" />

    <p class="copyright">
      © {{ currentYear }} RIBERA DEL RÍO. TODOS LOS DERECHOS RESERVADOS
    </p>
  </div>
</footer>
